import request from '@/utils/request'

export function selecTagstList () {
  return request({
    url: '/api/videoSearchHot',
    method: 'get'
  })
}

export function searchList (data) {
  return request({
    url: '/api/videosort/0',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/API/search.js